
import React, { useEffect, useState } from "react";
import { Products } from "./Products";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const ProductsSection = () => {
 const lang = useSelector((state) => state.cart.lang);
      const theme = useSelector((state) => state.cart.theme);
  const categories =useSelector((state) => state.cart.products);

  const [index,setIndex] = useState(0)

  

  const [animation,setAnimation] = useState(false)




  const [width, setWidth] = useState(window.innerWidth);
  
  useEffect(() => {

    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
  //  console.log(window.innerWidth);
    return () => window.removeEventListener("resize", handleResize);
    
  
  }, []);

  return (
    <section className=" mt-[8px] px-[3%]  w-full">
      <div className={`flex ${width >= 1000 ? '' : 'flex-col gap-1'}  pt-10 `} >
      <h2 style={{fontFamily:'CairoExtraBold'}} className= {` ${lang === 'en' ? "text-left" : "text-right"} text-[20px]  xl:text-[50px]  lg:text-[40px] md:text-[30px]   sm:text-[25px]  xs:text-[20px] `} >
      {lang === 'en' ? "Suggested Products" : "منتجات مقترحة"} 
          </h2>
          <div  style={{overflowX:'auto',overflowY:'hidden'}} className={`${theme === 'LM' ? 'light-scrollbar' : 'dark-scrollbar' } flex min-w-[70%] gap-2 p-1 py-4`} >
            {categories.map((category, i) => (
              <button
                key={i}
                onClick={()=>{
            
                 if(i!==index){
                 
                  setAnimation(true)
                  setTimeout(() => {
                    setIndex(i)
                 //   setProducts(category.products)
                    setAnimation(false);
                  }, 500)
                 }
                 
               //  console.log(JSON.stringify(category.products))
                }}
                className={`m-auto  transition-all duration-500  px-1 py-1  rounded-xl shrink-0 ${
                  index === i
                    ? `text-white drop-shadow-lg ${theme === 'LM' ? 'bg-primary text-white' : 'bg-primary_ text-[#000000]'  } px-3 ` 
                    : `${theme === 'LM' ? 'bg-zinc-100' : 'bg-zinc-700'  }  `
                } h-[50px] `}
              >
                {lang === 'en' ? category.value_en : category.value }
              </button>
            ))}
          </div>
      </div>
       
       {/* Custom <hr/> */}
      <div className={`flex mt-6 max-w-full  h-[3px] w-full  ${theme === 'LM' ? 'bg-zinc-200' : 'bg-zinc-600 ' }`}/>
    
     <Products lang={lang} products={categories.length > 0 ? categories[index].products :[]} animation={animation} />
     <br />
     <div className="w-full flex">
          <Link to={'Products'} style={{fontFamily:'CairoBold'}} className={`  ${theme === 'LM' ? ' text-primary' : ' text-primary_'  } mx-auto mt-2`} >
          {lang === 'en' ? 'View All Products' : 'عرض كل المنتجات' } 
          </Link>
          </div>
    </section>
  );
};
